'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/type.js
// module id = xTtY
// module chunks = 3